<h2 mat-dialog-title>Select Media from Patient File</h2>
<mat-dialog-content>
  <div class="media-list">
    <div *ngFor="let media of mediaList" 
         class="media-item" 
         [class.selected]="isSelected(media)"
         (click)="toggleMedia(media)">
      <mat-checkbox 
        [checked]="isSelected(media)"
        (click)="toggleMedia(media, $event)"
        class="media-checkbox">
      </mat-checkbox>
      <img *ngIf="isImage(media)" [src]="media.mediaUrl" [alt]="media.mediaFileName" class="media-preview">
      <div *ngIf="!isImage(media)" class="media-icon">
        <mat-icon>{{ getMediaIcon(media) }}</mat-icon>
      </div>
      <div class="media-info">
        <div class="media-name">{{ media.mediaFileName }}</div>
        <div class="media-type">{{ media.mediaType }}</div>
      </div>
    </div>
  </div>
  <div *ngIf="mediaList.length === 0" class="no-media">
    <mat-icon>folder_open</mat-icon>
    <p>No media files available for this patient.</p>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <span class="selected-count" *ngIf="selectedCount > 0">{{ selectedCount }} selected</span>
  <button mat-button (click)="close()">Cancel</button>
  <button 
    mat-raised-button 
    color="primary" 
    (click)="send()"
    [disabled]="selectedCount === 0">
    <mat-icon>add</mat-icon>
    Add Selected ({{ selectedCount }})
  </button>
</mat-dialog-actions>

